import * as React from 'react';
import { Inline } from '@origin-digital/ods-core';

import { divisionIdIconMap, divisionIdLabelMap, IDivisionIdWithLpg } from 'src/consts';

interface IProps {
  divisionId: IDivisionIdWithLpg;
}

const FuelIcon: React.SFC<IProps> = ({ divisionId }) => {
  const Icon = divisionIdIconMap[divisionId];

  return <Icon size={20} />;
};

export const FuelInformation: React.SFC<IProps> = ({ divisionId }) => (
  <Inline space="xxsmall" alignY="center" data-id="fuel-information">
    <FuelIcon divisionId={divisionId} />
    {divisionIdLabelMap[divisionId]}
  </Inline>
);
